var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMapMarker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marker"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7639-2",
    d: "M20,0A20,20,0,0,1,40,20c0,8.666-5.511,16.044-13.872,18.989C25.744,39.126,20,48,20,48s-6.175-8.918-6.894-9.161A20.038,20.038,0,0,1,20,0Z",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(4 4)",
    fill: "currentColor"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMapMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map-marker.8734d037fb7b32ab9bc6f9e075595ef1.svg";